import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  DeploymentRequestDetailPageContext,
  DeploymentRequestDetailPageInitialState,
} from ".";

export const DeploymentRequestDetailPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    DeploymentRequestDetailPageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <DeploymentRequestDetailPageContext.Provider value={context}>
      {children}
    </DeploymentRequestDetailPageContext.Provider>
  );
};
